import { camelCase } from "lodash";

export class LogModel {
  id: number = null;
  latitude: number = null;
  longitude: number = null;
  logAdc: number = null;
  logBv: number = null;
  logVehicleId: number = null;
  logTripId: string = null;
  logDateTime: string = null;
  logLocalDateTime: string = null;
  logServerDateTime: string = null;
  dateTimeNow: string = null;
  logFuelLevel: number = null;
  logRpm: number = null;
  logOdometer: number = null;
  logKpl: number = null;
  logHwOdometer: number = null;
  logRfid: number = null;
  logTrueOdometer: number = null;
  logEventid: string = null;
  logTempVoltage: string = null;
  logCog: number = null;
  address: string = null;
  altitude: string = null;
  speed: string = null;
  maxSpeed: string = null;
  rego: string = null;
  serialNo: string = null;
  driver: string = null;
  logNsat: number = null;
  lastCommunicationMinutes: number = null;
  iconName: string = null;
  vehicleStartOdometer: number = null;
  // fields calculated on the frontend
  tripStart?: boolean;
  tripEnd?: boolean;

  constructor(obj?: any) {
    for (const field in obj) {
      const camelCasedField = camelCase(field);
      if (typeof this[camelCasedField] !== "undefined") {
        this[camelCasedField] = obj && obj[field];
      }
    }
  }
}
